<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="저장" icon="pi pi-save" class="p-button-success mr-2" @click="btnAct('SAVE')" :disabled="!selectedItems || !selectedItems.length" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  :disabled="!searchParams.calcYm || !searchParams.calcCnt"/>
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  :disabled="!searchParams.calcYm || !searchParams.calcCnt"/>
            <FileUpload mode="basic" accept=".xlsx" :maxFileSize="10000000" 
                    @select="selectExcel" :auto="true" chooseLabel="엑셀업로드" :disabled="!searchParams.calcYm || !searchParams.calcCnt"/>
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field-0 p-float-label m-2">
                        <div class="p-inputgroup">
                            <InputText id="calcYm" v-model.trim="searchParams.calcYm" type="text" style="width:8rem" @keydown.enter="btnDialog('CodeHelpDialog', searchParams.calcYm)" />
                            <label for="calcYm">평가년도</label>
                            <Button icon="pi pi-search" class="p-button-search" @click="btnDialog('CodeHelpDialog', searchParams.calcYm)" />
                        </div>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="calcCnt" type="text" style="width:8rem" v-model="searchParams.calcCnt" disabled/>
                        <label for="calcCnt">평가차수</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.fromDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" disabled/>
                        <label>시작일자</label>
                    </div>
                    <div class="p-field p-float-label m-auto mr-2" style="width: 1rem">
                        <label>~</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.toDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" disabled/>
                        <label>종료일자</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="corpId" v-model="searchParams.corpId" :options ="corps" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem" scrollHeight="20em" :editable="true"/>
                        <label for="corpId">업체명</label>
                    </div>
                </div> 
            </template>

            <template #end>
                
            </template>
        </Toolbar>
        
        <DataTable id="dt" ref="dt" :value="dataList" v-model:selection="selectedItems" showGridlines 
                editMode="cell" @cell-edit-complete="onCellEditComplete" 
                scrollable="true" scrollHeight="79vh" class="p-datatable-sm" responsiveLayout="scroll">
            <Column header="No" style="min-width:3em; max-width:3em" exportFooter=" ">
                <template #body="{index}">
                    {{ index + 1 }}
                </template>    
            </Column>
            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false" exportFooter=" "></Column>
            <!-- <Column field="calcYm" header="calcYm" :sortable="false"></Column>
            <Column field="calcCnt" header="calcCnt" :sortable="false"></Column> -->
            <!-- <Column field="ctrPublicId" header="ctrPublicId" :sortable="false"></Column>
            <Column field="areaTag" header="areaTag" :sortable="false"></Column> -->
            <Column field="ctrPublicId" header="관할행정ID" :sortable="true" exportFooter=" "></Column>
            <Column field="ctrPublicNm" header="관할행정구역" :sortable="true" exportFooter=" "></Column>
            <Column field="corpId" header="업체ID" :sortable="true" exportFooter=" "></Column>
            <Column field="corpNm" header="업체명" :sortable="true" exportFooter=" "></Column>
            <Column field="areaTag" header="영역코드" :sortable="true" exportFooter=" "></Column>
            <Column field="areaTagNm" header="영역분류" :sortable="true" exportFooter=" "></Column>
            <Column field="kmCostAmt" header="Km당원가" :sortable="true" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" :maxFractionDigits="0" :min="0" :max="9999999999"  inputStyle="text-align: right"/>
                </template>
            </Column>
            <Column field="dateCostAmt" header="일일대당원가" :sortable="true" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" :maxFractionDigits="0" :min="0" :max="9999999999"  inputStyle="text-align: right"/>
                </template>
            </Column>
            <Column field="isSaved" header="체크" :sortable="false" hidden exportFooter=" "></Column>
        </DataTable>

        <CodeHelpDialog v-model:search="searchCodeHelp" v-model:selection="selectedCodeHelp" v-model:visible="isCodeHelpDialog" @onComplete="codeHelpComplete" />
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import MA201070Service from '@/service/ma/MA201070Service';
import CustService from '@/service/ma/CustService';
import JsUtils from '@/utilities/JsUtils';
import CodeHelpDialog from '@/components/CodeHelpDialog';
import XLSX from 'xlsx';


export default {
    components: {
        'CodeHelpDialog': CodeHelpDialog,
    },
    setup() {
        onMounted(() => {
            searchParams.compSeq = 1;
            custService.getCodeList(searchParams).then(data => {
                corps.value = data;
            });
        })
		//const codeService = new CodeService();
        const ma201070Service = new MA201070Service();
        const custService = new CustService();
        const searchParams = reactive({calcYm:null, calcCnt:null, corpId:null});
        const dataList = ref([]);
        const selectedItems = ref([]);
        const corps = ref([]);
        const rowIndex = ref(null);
        const confirm = useConfirm();
        const toast = useToast();
        const loading = ref(false);
        
        // 코드도움 Dialog
        const isCodeHelpDialog = ref(false);    // 코드도움다이얼로그 표시 여부
        const searchCodeHelp = reactive({helpId:"_calc_cnt", compSeq:1, conds:[{'calcYm':null}]});  // 코드도움 검색조건, 평가차수인 경우 코드도움ID "_calc_cnt", 검색조건 conds:[{'calcYm':null}]에서 calcYm는 평가년도 임 
        const selectedCodeHelp = ref({});       // 코드도움 다이얼로그 검색결과에서 선택된 항목

        const exceldataTemp = ref([]);
        const dataList2 = ref([]);

        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 
        const compCodes = ref([
            {codeNm: '경남도청', code: 1},
        ]);

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                    searchList();
                    break;
                case "SAVE":
                    saveList();
                    break; 
                default:
            }
        }

        const btnDialog = (_act, _str) => {
            switch(_act) {
                case 'CodeHelpDialog':
                    // CodeHelpDialog는 공통으로 사용하기 때문에 특정한 Id( ex: calcYm)로 넘기지말고 배열에 담아 넘겨야 한다
                    // 또한, CodeHelpDialog에 넘기는 검색조건도 하나 이상일 수 있다
                    searchCodeHelp.conds[0] = _str;  

                    // CodeHelpDialog를 표시한다
                    isCodeHelpDialog.value = true;

                    // 기존 검색조건을 초기화한다
                    searchParams.calcCnt = null;
                    searchParams.fromDate = null;
                    searchParams.toDate = null;
                    break;
                default:
                    break;
            }
        }

        const searchList = () => {
            // 검색조건에서 필수 입력값을 체크한다 - 검색데이터량이 많은 경우(예: 3천건 이상) 필수로 적용할 것!!!    
            if(!JsUtils.checkUndefineColumns(searchParams, ["calcYm", "calcCnt"])){
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'평가년도, 평가차수를 선택해주세요.', life:2000});
                return;
            }

            loading.value = true;
            ma201070Service.getList(searchParams).then(data => {
                 if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000}); 
                dataList.value = data;
                selectedItems.value = [];
            }).finally(() => {
                loading.value = false;
            });
        };

        const saveList = () => {
            confirm.require({
                message:'선택된 항목(들)을 저장하시겠습니까?',
                header: '저장',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    // selectedItems.value.forEach(row => {
                    //     //row.useYn = row.useYn == true ? 'Y' : 'N';    // Checkbox는 true or fale 값을 가지므로 Y' or 'N'으로 변환한다
                    // });

                    ma201070Service.updateList(selectedItems.value).then(() => {
                        // Datatable에서 선택된 행들을 초기화 한다
                        selectedItems.value = [];
                        searchList();
                        toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                    })
                    .catch(error => {
                        if (error.response) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 3000});
                        } else if (error.request) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 3000});	
                        } else {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 3000});	
                        }
                    });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            });
        };

        // 셀 편집 후, Datatable의 해당 행(Row)를 선택된 상태로 만든다
        const onCellEditComplete = (event) => {
            let { data, newValue, field } = event;
            if(data[field] === newValue) return;

            switch (field) {
                case "kmCostAmt":  // 평가대상시작일
                case "dateCostAmt": { // 평가대상종료일
                    data[field] = newValue;
                    break;
                }
                default:
                    break;
            }

            // 기존에 추가된 행이 아닌 경우에만 선택된 행 목록에 추가한다
            // 해당 Row를 유일하게 구분할 수 있는 값 사용
            // var _ = require('lodash');
            // const _row = _.find(selectedItems.value, {'ctrPublicNm': data.ctrPublicNm, 'corpId': data.corpId, 'areaTagNm': data.areaTagNm});

            // if(_row == null || _row == undefined) {
            //     selectedItems.value.push(data);
            // }

            // 기존에 추가된 행이 아닌 경우에만 선택된 행 목록에 추가한다
            // 해당 Row를 유일하게 구분할 수 있는 값 사용 예) corpId, lineId
            const _ = require('lodash');
            let _row = _.find(selectedItems.value, function(obj) {
                if (obj.rowNo === data.rowNo) {
                    return true;
                }
            });

            if(_row == null || _row == undefined) {
                selectedItems.value.push(data);
                if(data.rowNo != null && data.rowNo !="신규") {
                    data.rowNo = '수정';
                }
            }
        };

        // 코드도움 다이얼로그 목록에서 한 건을 선택하고 적용 버튼을 누른 경우, 선택된 건을 받아와서 현재 화면의 검색조건에 넣는다
        const codeHelpComplete = () => {
            searchParams.calcYm = selectedCodeHelp.value.CALC_YM;
            searchParams.calcCnt = selectedCodeHelp.value.CALC_CNT;
            searchParams.fromDate = selectedCodeHelp.value.CALC_FR_YMD;
            searchParams.toDate = selectedCodeHelp.value.CALC_TO_YMD;
        }

        // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
            var num = Number(value).toFixed(0);
            return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            dataList2.value = [];
            dataList.value.forEach(row => {
                dataList2.value.push({'관할행정ID':row.ctrPublicId,'관할행정구역':row.ctrPublicNm, '업체ID':row.corpId,'업체명':row.corpNm, '영역코드':row.areaTag, '영역분류':row.areaTagNm, 'Km당원가':row.kmCostAmt, '일일대당원가':row.dateCostAmt});
            }); 

            //let heading = [['No','주유일자','업체소재지','관할행정구역','업체명','영역분류','운행분류','차량ID','차량번호','사용연료','주유량',
            //                '주유금액','주유단가','주유소']];
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel3(dataList2.value, heading);
            JsUtils.downloadExcel(dataList2.value);
            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            //JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };


        //엑셀데이터 업로드 
        const selectExcel = (event) => {
            exceldataTemp.value = [];

            if(dataList.value.length == 0) {
                toast.add({severity:'warn', summary:'엑셀 오류', detail:'엑셀 업로드를 하기 위해서 먼저 해당 조건을 조회 해주세요!'});
                return;
            }

            const file = event.files[event.files.length - 1];
            let reader = new FileReader();
            reader.onload = () => {
                let data = reader.result; 
                //var workbook = XLSX.read(data, {type: 'binary', cellDates: true, dateNF: 'YYYY-MM-DD'}); // 엑셀 날짜 형식을 date type으로 변경한다
                var workbook = XLSX.read(data, {type: 'binary'});
                const sheetnames = Object.keys(workbook.Sheets);
                const sheetname = sheetnames[0]; // 첫번째 워크시트

                const worksheet = workbook.Sheets[sheetname];
                const options = { header: 1 };
                const sheetData = XLSX.utils.sheet_to_json(worksheet, options);
                const header = sheetData.shift();
                var header_Count = 0;
                //alert(JSON.stringify(header));
                header.forEach(element => {
                    if(element != null && element.replace(/ /g,"") != "") {
                        header_Count++;
                    }
                });

                if(header_Count != 8) {
                    toast.add({severity:'warn', summary:'엑셀 양식 오류', detail:'컬럼의 갯수가 다릅니다. 공지사항의 엑셀업로드 양식 사용법을 참조하십시오.'});
                    return;
                }

                workbook.Sheets[sheetname].A1.w = "ctrPublicId";         //관할행정
                workbook.Sheets[sheetname].B1.w = "ctrPublicNm";         //관할행정
                workbook.Sheets[sheetname].C1.w = "corpId";      //업체ID
                workbook.Sheets[sheetname].D1.w = "corpNm";       //업체명
                workbook.Sheets[sheetname].E1.w = "areaTag";          //영역코드
                workbook.Sheets[sheetname].F1.w = "areaTagNm";          //영역분류
                workbook.Sheets[sheetname].G1.w = "kmCostAmt";       //Km당원가
                workbook.Sheets[sheetname].H1.w = "dateCostAmt";    //일일대당원가

                exceldataTemp.value = XLSX.utils.sheet_to_json(workbook.Sheets[sheetname]);

                console.log(exceldataTemp);

                selectedItems.value = [];

                exceldataTemp.value.find(row => {
                    dataList.value.find(data2 => {
                        if(row.corpId == data2.corpId && row.ctrPublicId == data2.ctrPublicId && row.areaTag == data2.areaTag){
                                data2.kmCostAmt = row.kmCostAmt;
                                data2.dateCostAmt = row.dateCostAmt;
                                selectedItems.value.push(data2);
                            }
                        })
                    }
                );

            }
            reader.readAsBinaryString(file);
        }

        return { 
            dt, dataList, selectedItems, searchParams, corps, rowIndex, compCodes, loading,
            isCodeHelpDialog, searchCodeHelp, selectedCodeHelp, codeHelpComplete, onCellEditComplete, 
            btnAct, searchList, btnDialog, formatToPrice, downloadExcel, exportCSV,  selectExcel
        }

    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
